import React from 'react';
import { FiCalendar, FiClock, FiEdit3, FiCheckCircle, FiArchive, FiSend } from 'react-icons/fi';

const CONFIGS = {
  timeline: {
    icon: FiCalendar,
    iconBg: 'bg-indigo-100 text-indigo-600',
    title: 'No scheduled posts yet',
    description: 'Create your first post and schedule it to see it appear on the timeline.',
    ctaLabel: 'Create Post',
  },
  queue: {
    icon: FiClock,
    iconBg: 'bg-violet-100 text-violet-600',
    title: 'Queue is empty',
    description: 'Approved and queued posts will appear here. Submit a post for approval to get started.',
    ctaLabel: 'View Drafts',
  },
  drafts: {
    icon: FiEdit3,
    iconBg: 'bg-zinc-100 text-zinc-500',
    title: 'No drafts or pending reviews',
    description: 'Start composing a new post or submit an existing draft for approval.',
    ctaLabel: 'New Post',
  },
  history: {
    icon: FiArchive,
    iconBg: 'bg-emerald-100 text-emerald-600',
    title: 'No post history yet',
    description: 'Published, canceled, and failed posts will show up here for review.',
  },
  approval: {
    icon: FiCheckCircle,
    iconBg: 'bg-amber-100 text-amber-600',
    title: 'Nothing pending approval',
    description: 'Posts submitted for review will appear here.',
  },
  general: {
    icon: FiSend,
    iconBg: 'bg-indigo-100 text-indigo-600',
    title: 'No posts found',
    description: 'Create a new post to get started with social publishing.',
    ctaLabel: 'Create Post',
  },
};

export default function PostEmptyState({ type = 'general', onAction, className = '' }) {
  const config = CONFIGS[type] || CONFIGS.general;
  const Icon = config.icon;

  return (
    <div className={`flex flex-col items-center justify-center py-16 px-6 ${className}`}>
      <div className={`w-16 h-16 rounded-2xl ${config.iconBg} flex items-center justify-center mb-5 shadow-sm`}>
        <Icon className="w-7 h-7" />
      </div>
      <h3 className="text-base font-semibold text-zinc-800 mb-1.5">{config.title}</h3>
      <p className="text-sm text-zinc-500 text-center max-w-sm leading-relaxed">{config.description}</p>
      {config.ctaLabel && onAction && (
        <button
          onClick={onAction}
          className="mt-5 px-5 py-2.5 rounded-xl text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm hover:shadow-md transition-all"
        >
          {config.ctaLabel}
        </button>
      )}
    </div>
  );
}
